import { render, staticRenderFns } from "./ProAppointmentsAPage.vue?vue&type=template&id=22098f69"
import script from "./ProAppointmentsAPage.vue?vue&type=script&lang=js"
export * from "./ProAppointmentsAPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports